var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var Tags = /** @class */ (function (_super) {
    __extends(Tags, _super);
    function Tags() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.system = null;
        _this.user = null;
        return _this;
    }
    // Indicates if a question block can be configured for prefill
    Tags.PREFILL_CONFIGURABLE = 'prefillable';
    // Indicates a question has been configured and allows prefill
    Tags.PREFILL_ALLOWED = 'prefill_allowed';
    // Prefix for source of prefill
    Tags.PREFILL_SOURCE = 'source';
    // Indicates a question has been prefilled
    Tags.PREFILLED = 'prefilled';
    // Denotes the contact group
    Tags.CONTACT = 'contact';
    // Denotes the application group
    Tags.APPLICATION = 'application';
    // Indicates the question contains a email that can be used to create a talent
    Tags.TALENT_EMAIL = 'respondent_email';
    // Indicates the answer is a name of a talent
    Tags.TALENT_NAME = 'respondent_name';
    // Indicates a talent phone number
    Tags.TALENT_PHONE = 'respondent_phone';
    return Tags;
}(Entity));
export { Tags };
